import styled from 'styled-components';
import { friendlyShortImpactTitle } from '../../../../../../../../../../../common/utils';
import { BouColor } from '../../../../../../../../../generic/global/bou-colors';
import {
  useImpactChartContext,
  useImpactChartFontSizes,
  useImpactChartHeights,
  useImpactChartWidths,
} from '../../../../context';
import { ImpactRowProps } from '../types';

const TitleText = styled.text`
  fill: ${BouColor.BLACK};
  cursor: pointer;
  transition: fill 0.12s ease-in-out;
  &:hover {
    fill: ${BouColor.TOOL_TEXT_LIGHT_GRAY};
  }
  &:active {
    fill: ${BouColor.TOOL_TEXT_LIGHT_GRAY};
  }
`;

export function ImpactRowLeftPart(props: ImpactRowProps) {
  const widths = useImpactChartWidths();
  const heights = useImpactChartHeights();
  const { impactTitles } = useImpactChartFontSizes();
  const { language } = useImpactChartContext();
  const height = heights.impactRow;
  return (
    <g transform={`translate(${widths.titleTextLeftLine}, ${height / 2})`}>
      <TitleText dy="0.35em" onClick={props.onTitleClick} style={{ fontSize: impactTitles }}>
        {friendlyShortImpactTitle(props.impactCode, language)}
      </TitleText>
    </g>
  );
}
